import { defineComponent, computed, createElementBlock, openBlock, createCommentVNode, createElementVNode, Fragment, renderList } from 'vue';

const _hoisted_1 = { class: "responsive-picture" };
const _hoisted_2 = ["type", "srcset", "sizes"];
const _hoisted_3 = ["src", "alt", "width", "height", "loading", "fetchpriority"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ResponsiveImage",
  props: {
    image: {},
    sizes: {},
    lazyload: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const sourcesets = computed(() => {
      if (Array.isArray(props.image.sources)) {
        return props.image.sources;
      }
      if (!props.image.srcset) {
        return [];
      }
      const sources = [];
      sources.push({
        srcset: props.image.srcset,
        mimeType: props.image.mimeType
      });
      return sources;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("picture", _hoisted_1, [
        sourcesets.value.length > 0 ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(sourcesets.value, (srcset) => {
          return openBlock(), createElementBlock("source", {
            key: srcset.srcset,
            type: srcset.mimeType,
            srcset: srcset.srcset,
            sizes: _ctx.sizes
          }, null, 8, _hoisted_2);
        }), 128)) : createCommentVNode("", true),
        createElementVNode("img", {
          ref: "img",
          src: _ctx.image.src,
          alt: _ctx.image?.alt,
          width: _ctx.image?.width,
          height: _ctx.image?.height,
          loading: _ctx.lazyload ? "lazy" : void 0,
          fetchpriority: !_ctx.lazyload ? "high" : void 0
        }, null, 8, _hoisted_3)
      ]);
    };
  }
});

export { _sfc_main as default };
